<template>
    <div id="TrainerRegister">
        <div class="section">
            <div class="row">
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <h3>Trainer Register</h3>
                </div>
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <form action="index.html">
                        <div class="input-field">
                            <i class="material-icons prefix">email</i>
                            <input type="email" id="email" v-model="email">
                            <label for="email">E-Mail</label>
                        </div>
                        <div class="input-field">
                            <i class="material-icons prefix">lock</i>
                            <input type="password" id="password" v-model="password">
                            <label for="password">Password</label>
                        </div>
                        <button v-on:click="register" class="btn btn-medium btn-extended">Register</button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <span>Already have an account? <router-link to="/TrainerLogin">Login</router-link></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import firebase from 'firebase';

export default {
    name: 'TrainerRegister',
    data: function() {
        return{
            email:'',
            password:'',
        }
    },
    methods: {
        register: function(event) {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .then(user => {
                alert('Account created for ' + user.user.email);
                this.$router.push('/');
            },
            err => {
                alert(err.message);
            })
            event.preventDefault();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/TrainerRegister.vue